module.exports = __webpack_public_path__ + "img/duda.9c69d24f.jpg";